import { faStar } from '@fortawesome/pro-solid-svg-icons';

import { LabeledField } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/_primitives/labeled-field.component';
import { Icon } from '@/components/ui/icon.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { AppointmentRating } from '@/types';

interface AppointmentReviewSummaryProps {
  id: string;
  rating: NonNullable<AppointmentRating['rating']>;
}

export function AppointmentReviewSummary({ id, rating }: AppointmentReviewSummaryProps) {
  const ratingValue = rating.professional?.value ?? rating.partnerFacility?.value ?? 0;
  const displayRating = ratingValue.toFixed(1).replace('.', ',');

  return (
    <LabeledField label="Avaliação">
      <div className="flex items-center gap-2">
        <Icon icon={faStar} className="text-warning-400" />
        <Typography variant={TypographyVariant.BODY_TEXT}>{displayRating}</Typography>
        <Link
          prefetch={false}
          href={`/agendamentos/${id}/avaliar/`}
          className="text-green-500 font-semibold px-4 py-2"
        >
          Ver mais
        </Link>
      </div>
    </LabeledField>
  );
}
